import DialogLayout from 'components/dialog-layout/dialog-layout';

export default DialogLayout;
